/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */

import normalizeColor from "./modules/normalizeColor"
import { ShadowStyles } from "./types/styles"
import normalizeValueWithProperty from "./normalizeValueWithProperty"

const defaultOffset = { height: 0, width: 0 }

const resolveShadowValue = (style: ShadowStyles) => {
  const { shadowColor, shadowOffset, shadowOpacity, shadowRadius } = style
  const { height, width } = shadowOffset || defaultOffset
  const offsetX = normalizeValueWithProperty(width ?? 0)
  const offsetY = normalizeValueWithProperty(height ?? 0)
  const blurRadius = normalizeValueWithProperty(shadowRadius || 0)
  const color = normalizeColor(shadowColor || "black", shadowOpacity)
  if (
    color != null &&
    offsetX != null &&
    offsetY != null &&
    blurRadius != null
  ) {
    return `${offsetX} ${offsetY} ${blurRadius} ${color}`
  }
  return undefined
}

export default resolveShadowValue
